import React, { useState } from 'react'

import { PageHeader, WebphoneModal } from 'components/shared'
import { ReactComponent as LocalIcon } from 'assets/svg/recents/local.svg'
import { ReactComponent as IncomingIcon } from 'assets/svg/recents/incoming.svg'
import { ReactComponent as OutgoingIcon } from 'assets/svg/recents/outgoing.svg'
import { ReactComponent as VoicemailIcon } from 'assets/svg/recents/voicemail.svg'
import { visualNumberFormat } from 'utils/numberUtils'
import { useTranslation } from 'react-i18next'
import { CallDirection } from 'common/Enums'

export const RecentCalls = ({ recentCalls }) => {
    const [contactDetails, setContactDetails] = useState(null)
    const [isModalVisible, setModalVisible] = useState(false)
    const toggleModal = () => setModalVisible(!isModalVisible)

    const getCallItemNumber = (item) => item.outside_number || item.destination_number

    const handleOnContactClick = (item) => {
        toggleModal()
        const number = getCallItemNumber(item);
        setContactDetails({ phoneNumber: visualNumberFormat(number), ...item })
    }

    const modalData = {
        imgSrc: contactDetails?.userAvatar,
        text: visualNumberFormat(contactDetails?.phoneNumber),
        phoneNumber: contactDetails?.phoneNumber,
        duration: contactDetails?.duration_time
    }

    function renderRecentCallItem(item) {
        const { uuid, direction, start_stamp, status, lead } = item
        const number = getCallItemNumber(item);
        const callStatusClass = status || ''
        const callDirectionClass = direction || ''
        const leadName = lead?.name || ''

        const CallDirectionIcon = () => {
            switch (direction) {
                case CallDirection.Local:
                    switch (status) {
                        case 'voicemail':
                            return <VoicemailIcon />
                        default:
                            return <LocalIcon />
                    }
                case CallDirection.Outgoing:
                    return <OutgoingIcon />
                default:
                    return <IncomingIcon />
            }
        }

        return (
            <div
                key={uuid}
                className={`recents__item d-flex justify-content-between align-items-center ${
                    leadName && 'lead-found'
                }`}
                onClick={() => handleOnContactClick(item)}
            >
                <div className={`d-flex flex-fill align-items-center ${callDirectionClass} ${callStatusClass}`}>
                    <CallDirectionIcon />
                    {leadName ? (
                        <div className="d-flex flex-column">
                            <span className="lead-name">{leadName}</span>
                            <span className="ltr number small">{visualNumberFormat(number)}</span>
                        </div>
                    ) : (
                        <span className="ltr number">{visualNumberFormat(number)}</span>
                    )}
                </div>
                <span className="recents__item__date">{start_stamp}</span>
            </div>
        )
    }

    const { t } = useTranslation()

    return (
        <div className="recents">
            <PageHeader pageName={t('navigation.recents')} />
            {recentCalls.map((item) => renderRecentCallItem(item))}
            <WebphoneModal {...{ isModalVisible, toggleModal, modalData }} />
        </div>
    )
}
